"use client";

import React, { PropsWithChildren } from "react";
import { Carousel } from "flowbite-react";
import Image from "next/image";

function FeedbacksCarousel({ children }: PropsWithChildren) {
  return (
    <Carousel
      indicators={false}
      dir="ltr"
      leftControl={
        <div className="w-[5.8rem] max-lg:translate-x-[-19px] hover:-translate-x-12 transition-all   ease-in duration-600">
          <Image
            width={29}
            height={29}
            className={` -rotate-90  bg-secondary 
          lg:w-[3.5rem] lg:h-[3.5rem] w-[32px] h-[32px]  p-[0.8rem] rounded-full   `}
            src="/icons/arrowTop.svg"
            alt="Previous feedback"
          />
        </div>
      }
      rightControl={
        <div
          dir="rtl"
          className="w-[5.8rem] rtl hover:translate-x-12 max-lg:translate-x-[19px] transition-all   ease-in duration-600"
        >
          <Image
            width={29}
            height={29}
            className={` rotate-90  bg-secondary lg:w-[3.5rem] lg:h-[3.5rem] w-[32px] h-[32px]  p-[0.8rem] rounded-full   `}
            src="/icons/arrowTop.svg"
            alt="Next feedback"
          />
        </div>
      }
    >
      {children}
    </Carousel>
  );
}

export default FeedbacksCarousel;
